import { useTranslation } from 'next-i18next'
import styled from 'styled-components'

import { colors } from '@/styles'
import { ArrowLeftGrey08 } from '@/components/icons'

const BackButtonItem = styled.button`
  font-size: 18px;
  line-height: 24px;
  font-weight: 600;
  color: ${colors.grey08};
  text-decoration: none;
  background: none;
  gap: 10px;
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 8px 8px 8px 4px;
`

const BackButton = ({ onClick }) => {
  const { t } = useTranslation()

  return (
    <BackButtonItem onClick={onClick}>
      <ArrowLeftGrey08 width={14} height={14} />
      {t('common.back', 'Back')}
    </BackButtonItem>
  )
}

export default BackButton
